<template>
  <div class="form-textarea">
    <BFormGroup
      :label="label"
      :label-for="$attrs.id"
      :disabled="$attrs.disabled"
      :invalid-feedback="errorMessage"
    >
      <BFormTextarea
        :value="value"
        :state="state"
        :aria-label="label || $attrs.placeholder"
        v-bind="$attrs"
        v-on="$listeners"
      />
    </BFormGroup>
  </div>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue/src/components/form-group/form-group'
import {BFormTextarea} from 'bootstrap-vue/src/components/form-textarea/form-textarea'

export default {
  components: {
    BFormGroup,
    BFormTextarea,
  },

  props: {
    /**
     * The current value of the textarea. Result will always be a string.
     */
    value: {
      type: [String, Number],
      default: undefined,
    },

    /**
     * Text to place in the label/legend of the form group
     */
    label: {
      type: String,
      default: undefined,
    },

    /**
     * Controls the validation state appearance of the component. 'true' for valid, 'false' or 'null' for no validation state
     */
    isInvalid: {
      type: Boolean,
      default: false,
    },

    /**
     * Text to show when the form group has an invalid state
     */
    errorMessage: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    state () {
      if (this.errorMessage && (this.errorMessage.length > 0)) {
        return false
      } else if (this.isInvalid) {
        return false
      } else {
        return null
      }
    },
  },
}
</script>

<style lang="scss">
.form-textarea {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;

  textarea.form-control {
    line-height: 1.43;
  }
}
</style>
